import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton, Stack, Tooltip } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router';

import { usePageContext } from '@/context/pageContext/Page.context.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

const TopBarNavigation: React.FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslationWithPrefix('pageTitles');
  const { pageDetails } = usePageContext();
  const navigate = useNavigate();

  const handleBack = () => {
    if (!pageDetails.backButtonUrl) {
      return;
    }
    void navigate(pageDetails.backButtonUrl);
  };

  return (
    <Stack alignItems="center" direction="row" spacing={3}>
      <Tooltip title={pageDetails.backButtonId ? `${t('backTo')} ${t(pageDetails.backButtonId)}` : ''}>
        <IconButton
          color="primary"
          disabled={!pageDetails.backButtonId}
          onClick={handleBack}
          size="medium"
          sx={!pageDetails.backButtonId ? { visibility: 'hidden' } : undefined}
          variant="contained"
        >
          <ArrowBackIcon />
        </IconButton>
      </Tooltip>
      {children}
    </Stack>
  );
};

export default TopBarNavigation;
